import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "BaseItemDialog__section flex-1" }
const _hoisted_2 = { class: "row items-center no-wrap gap-12 flex-1 q-px-12 full-width" }
const _hoisted_3 = { class: "column flex-1 overflow-hidden" }
const _hoisted_4 = { class: "fs-13px text-cool-gray-70" }
const _hoisted_5 = { class: "fs-17px fw-600 text-cool-gray-100 full-width break-word" }
const _hoisted_6 = { class: "row items-center no-wrap gap-12 flex-1 q-px-12 full-width" }
const _hoisted_7 = { class: "column flex-1 overflow-hidden" }
const _hoisted_8 = { class: "fs-13px text-cool-gray-70" }
const _hoisted_9 = { class: "fs-17px fw-600 text-cool-gray-100 full-width break-word" }
const _hoisted_10 = { class: "BaseItemDialog__section-header bg-white mb-n-2px" }
const _hoisted_11 = { class: "fs-15px fw-600 text-cool-gray-100 block q-mb-sm" }
const _hoisted_12 = { class: "BaseItemDialog__section-body flex column no-wrap gap-lg" }
const _hoisted_13 = { class: "flex items-center gap-12" }

import { onBeforeMount, reactive } from 'vue'
import { formatMonetaryAmount } from 'src/common/helpers/generator/monetaryAmount.helper'
import translate from 'src/common/helpers/language/translate'
import globalTranslateObject from 'src/translate/global.translate'
import { IItemView } from 'src/common/interfaces'
import BaseItemDialogStateIndicator from './BaseItemDialogStateIndicator.vue'
import _ from 'lodash'

interface IProps {
  item: IItemView
  currency: string
}

interface ITableRow {
  salesType: string
  cost: string | number
  price: string | number
}

interface IState {
  rows: ITableRow[]
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogPricing' },
  __name: 'BaseItemDialogPricing',
  props: {
    item: {},
    currency: {}
  },
  setup(__props: any) {


const props = __props

const { t: globalT } = translate(globalTranslateObject)

const tableColumnClasses = {
  headerClasses: 'q-px-sm',
  labelClasses: 'fs-13px text-cool-gray-100',
}

const columns = [
  {
    label: globalT('sales_type'),
    align: 'left',
    field: 'salesType',
    slot: 'salesType',
    name: 'salesType',
    ...tableColumnClasses,
  },
  {
    label: globalT('price'),
    align: 'left',
    field: (row: ITableRow) => formatMonetaryAmount(row.price, props.currency),
    slot: 'price',
    name: 'price',
    style: 'width: 20%',
    ...tableColumnClasses,
  },
]

const state = reactive<IState>({ rows: [] })

/**
 * Generates the rows for the Pricing table based on the data fetched from the server
 */
function generatePricingTableRows() {
  if (props.item.price_type === 0) {
    // Pricing is the same for all sales types
    state.rows = [
      {
        salesType: globalT('all_sales_type'),
        cost: props.item.default_cost,
        price: props.item.default_price,
      },
    ]
  } else {
    // Pricing is different for each sales type
    if (!_.isEmpty(props.item.sales_type_price_date)) {
      state.rows = []
      for (const salesType in props.item.sales_type_price_date) {
        const row = {
          salesType,
          cost: props.item.default_cost,
          price: props.item.sales_type_price_date[salesType],
        }
        state.rows.push(row)
      }
    }
  }
}

onBeforeMount(() => generatePricingTableRows())

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_table = _resolveComponent("k-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.item.plu || __props.item.barcode)
      ? (_openBlock(), _createBlock(BaseItemDialogStateIndicator, {
          key: 0,
          paddingless: "",
          class: "q-py-12 q-mb-lg"
        }, _createSlots({ _: 2 /* DYNAMIC */ }, [
          (__props.item.plu)
            ? {
                name: "left",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_k_icon, {
                      name: "individual-item",
                      size: "32px",
                      color: "space-b-100"
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(globalT)('sku')), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.item.plu), 1 /* TEXT */)
                    ])
                  ])
                ]),
                key: "0"
              }
            : undefined,
          (__props.item.barcode)
            ? {
                name: "right",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_k_icon, {
                      name: "barcode-2",
                      size: "32px",
                      color: "space-b-100"
                    }),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(globalT)('barcode')), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(__props.item.barcode), 1 /* TEXT */)
                    ])
                  ])
                ]),
                key: "1"
              }
            : undefined
        ]), 1024 /* DYNAMIC_SLOTS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(globalT)('pricing')), 1 /* TEXT */),
      _createVNode(_component_k_divider, { size: "md" })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_k_table, {
        columns: columns,
        rows: state.rows,
        "has-footer": false
      }, {
        salesType: _withCtx(({ col }) => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", {
              class: _normalizeClass(col.labelClasses)
            }, _toDisplayString(col.value), 3 /* TEXT, CLASS */)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["rows"]),
      _createVNode(BaseItemDialogStateIndicator, {
        left: { label: _unref(globalT)('discountable'), value: __props.item.is_discountable },
        right: { label: _unref(globalT)('refundable'), value: __props.item.is_refundable }
      }, null, 8 /* PROPS */, ["left", "right"])
    ])
  ]))
}
}

})